import {questions} from "@constants/common";
import _ from 'lodash'

export function generateEmptyAnswersFromConfig(data) {
    let result = [];
    for (let i = 0; i < data.length; i++) {
        switch (data[i].type) {
            case questions.types.section:
                result.push({
                    profileId: data[i].profileId,
                    type: data[i].type,
                    id: data[i].id,
                    children: data[i].children ? generateEmptyAnswersFromConfig(data[i].children) : null
                })
                break
            case questions.types.options: {
                result.push(generateEmptyAnswersFromConfig(data[i].children));
                break;
            }
            case questions.types.notice:
                result.push({
                    type: data[i].type,
                    children: null,
                    answer: !_.isEmpty(data[i].answer) ? {
                        text: data[i].answer.text,
                        images: data[i].answer.images.map(img => ({
                            filePath: img.url
                        }))
                    } : ""
                })
                break;
            default: {
                result.push({
                    answer: !_.isEmpty(data[i].answer) ? data[i].answer.action.value : '',
                    answerId: !_.isEmpty(data[i].answer) ? data[i].answer.action.id : null,
                    profileId: data[i].profileId,
                    type:data[i].type,
                    id: data[i].id,
                    children: data[i].children ? generateEmptyAnswersFromConfig(data[i].children) : null
                })
            }
        }
    }
    return result;
}

export function changeAnswer(answers, keys, value, id) {
    const key = keys[0];
    if (typeof answers[key] === 'undefined') return answers;
    if (Array.isArray(answers[key])) {
        keys.shift();
        answers[key] = changeAnswer(answers[key], keys, value, id)
    } else {
        if (keys.length === 1) {
            answers[key].answer = value
            answers[key].answerId = id
        } else if(answers[key].children){
            keys.shift();
            answers[key].children = changeAnswer(answers[key].children, keys, value, id)
        }
    }
    return answers
}

export function getAnswer(answers, keys) {
    const key = keys[0];
    if (typeof answers[key] === 'undefined') return '';
    if (Array.isArray(answers[key]) && keys.length >1) {
        keys.shift();
        return getAnswer(answers[key], keys);
    } else {
        if (keys.length <= 1) {
            return  answers[key]
        } else if(answers[key].children){
            keys.shift();
            return getAnswer(answers[key].children, keys)
        }
    }
}
